import React from 'react'
import styled from 'styled-components'
import H1 from '../../commons/H1'
import arrow from '../../../img/right_arrow_broken_darker.png'
import H2 from '../../commons/H2'

const Pluses = () => {
    return (
    <Container>
        <StyledH1>PERCHE SCEGLIERE PRESTITOPUOI</StyledH1>
      <StagesContainer>
        <Stage>
          <StyledH2>Un unico punto di accesso al credito</StyledH2>
        </Stage>
        <Img src={arrow} alt={"Freccia verso destra"}/>
        <Stage>
          <StyledH2>Supporto e guida da parte di un consulente</StyledH2>
        </Stage>
        <Img src={arrow} alt={"Freccia verso destra"}/>
        <Stage>
          <StyledH2>Collaborazione con primari istituti e intermediari finanziari</StyledH2>
        </Stage>
        <Img src={arrow} alt={"Freccia verso destra"}/>
        <Stage>
          <StyledH2>Chiarezza sul percorso, fin dal primo contatto</StyledH2>
        </Stage>
      </StagesContainer>
    </Container>
  )
}

// region Style
const Container = styled.div`
  max-width: 1125px;
  margin: 6rem auto 6rem auto;
  padding: 0 15px;
`
const StyledH1 = styled(H1)`
    @media (min-width: 769px) {
        font-size: 31px;
        letter-spacing: 1px;
    }
    font-size: 28px;
    letter-spacing: 0;
    margin-bottom: 2rem;
`
const StagesContainer = styled.div`
  @media (max-width: 480px) {
    flex-direction: column;
  }
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`
const Stage = styled.div`
  width: 100%;
  background-color: white;
  color: #f29505;
  //color: linear-gradient(169deg, #f3b706 0%, #f29505 100%);
  border-radius: 10px;
  padding: 1rem 1rem;
  height: 12rem;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Img = styled.img`
  @media (max-width: 480px) {
    transform: rotate(90deg);
  }
  width: 5rem;
`
const StyledH2 = styled(H2)`
  color: #222;
  margin: unset;
  font-size: 2.2rem;
    @media (max-width: 850px) {
        font-size: 1.6rem;
    }

    @media (max-width: 480px) {
        font-size: 1.3rem;
    }
`
// endregion

export default Pluses
